import * as Scrivito from "scrivito";

Scrivito.provideEditingConfig("CheckboxOptionWidget", {
  title: "Checkbox option",
  attributes: {
    text: {
      title: "Text",
      description: "This is the value that will be displayed in the form",
    },
  },
  properties: ["text"],
  validations: [
    [
      "text",
      (text) => {
        if (!text) {
          return "Text field is required";
        }
        return null;
      },
    ],
  ],
});
